import React, { useState, useEffect } from 'react';

const OpponentDetailsOverlay = ({ opponent, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    id: null,
    firstName: '',
    lastName: '',
    utr: '',
    club: '',
    wtn: '',
  });

  useEffect(() => {
    if (opponent) {
      setFormData({
        id: opponent.id,
        firstName: opponent.firstName || '',
        lastName: opponent.lastName || '',
        utr: opponent.utr || '',
        club: opponent.club || '',
        wtn: opponent.wtn || '',
      });
    } else {
      setFormData({
        id: null,
        firstName: '',
        lastName: '',
        utr: '',
        club: '',
        wtn: '',
      });
    }
  }, [opponent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">
          {opponent ? 'Edit Opponent' : 'Add New Opponent'}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="firstName" className="block text-gray-700 text-sm font-bold mb-2">
              First Name:
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="lastName" className="block text-gray-700 text-sm font-bold mb-2">
              Last Name:
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="utr" className="block text-gray-700 text-sm font-bold mb-2">
              UTR:
            </label>
            <input
              type="text"
              id="utr"
              name="utr"
              value={formData.utr}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="wtn" className="block text-gray-700 text-sm font-bold mb-2">
              WTN:
            </label>
            <input
              type="text"
              id="wtn"
              name="wtn"
              value={formData.wtn}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="club" className="block text-gray-700 text-sm font-bold mb-2">
              Club:
            </label>
            <input
              type="text"
              id="club"
              name="club"
              value={formData.club}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-green-800 px-4 py-2 rounded-md hover:bg-gray-400 mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              {opponent ? 'Save Changes' : 'Add Opponent'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OpponentDetailsOverlay;


